import Phaser from 'phaser';
import { wait } from 'tower/util';
import BaseScene from './base';

export default class LevelIntroScene extends BaseScene {
  constructor(config: Phaser.Types.Scenes.SettingsConfig = {}) {
    super({
      key: 'level-intro',
      ...config,
    });
  }

  create() {
    super.create();

    const levelText = this.add.bitmapText(96, 104, 'textWhite', 'FLOOR 1');

    (async () => {
      await wait(this, 2000);
      levelText.setVisible(false);

      await wait(this, 250);
      this.scene.start('battle');
    })();
  }

  update() {}
}
